/**
 * @link https://mui.com/material-ui/react-breadcrumbs/
 */

import * as React from 'react';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import ShowCode from "../../helpers/ShowCode.js";

function handleClick(event) {
  event.preventDefault();
  alert('You clicked a breadcrumb.');
}

export default function FactureeBreadcrumbs() {
  return (
    <>
      <div role="presentation" onClick={handleClick}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link underline="hover" color="inherit" href="/test-app-ts/public">
            MUI
          </Link>
          <Link
            underline="hover"
            color="inherit"
            href="/material-ui/getting-started/installation/"
          >
            Core
          </Link>
          <Typography color="text.primary">Breadcrumbs</Typography>
        </Breadcrumbs>
      </div>
      
      <ShowCode 
        codeString={`function BreadcrumbsExample() {
  // Handle click on breadcrumb items
  function handleClick(event) {
    event.preventDefault();
    alert('You clicked a breadcrumb.');
  }

  return (
    <div role="presentation" onClick={handleClick}>
      <Breadcrumbs aria-label="breadcrumb">
        {/* Clickable breadcrumb links */}
        <Link underline="hover" color="inherit" href="/">
          MUI
        </Link>
        <Link
          underline="hover"
          color="inherit"
          href="/material-ui/getting-started/"
        >
          Core
        </Link>
        
        {/* Current page (not a link) */}
        <Typography color="text.primary">Breadcrumbs</Typography>
      </Breadcrumbs>
    </div>
  );
}`} 
        scope={{ 
          React, 
          Typography, 
          Breadcrumbs, 
          Link 
        }} 
      />
    </>
  );
}